import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { translate } from '@/i18n';
import { showToast } from '@/utils';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonTitle,
  IonToolbar,
  modalController,
} from '@ionic/vue';
import { closeOutline, saveOutline } from 'ionicons/icons';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: ["profile"],
  setup(__props) {

const props = __props



const changePassword = ref({
  userId: props.profile.userId,
  oldPassword: '',
  newPassword: '',
  newPasswordVerify: ''
});

const cancel = () => modalController.dismiss(null, 'cancel');
const confirm = () => {
  const { oldPassword, newPassword, newPasswordVerify } = changePassword.value;
  if (!oldPassword.trim() || !newPassword.trim() || !newPasswordVerify.trim()) {
    showToast(translate("Please fill in all fields before submitting."));
    return;
  }
  if (newPassword !== newPasswordVerify) {
    showToast(translate("Password is not matching with confirm password."));
    return;
  } else {
    modalController.dismiss(changePassword.value, 'save');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  color: "medium",
                  onClick: cancel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), { icon: _unref(closeOutline) }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Change Password")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonItem), { lines: "full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInput), {
              "label-placement": "floating",
              label: _unref(translate)('Old Password'),
              modelValue: changePassword.value.oldPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((changePassword.value.oldPassword) = $event)),
              type: "password"
            }, null, 8, ["label", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonItem), { lines: "full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInput), {
              "label-placement": "floating",
              label: _unref(translate)('New Password'),
              modelValue: changePassword.value.newPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((changePassword.value.newPassword) = $event)),
              type: "password"
            }, null, 8, ["label", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonItem), { lines: "full" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInput), {
              "label-placement": "floating",
              label: _unref(translate)('Confirm Password'),
              modelValue: changePassword.value.newPasswordVerify,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((changePassword.value.newPasswordVerify) = $event)),
              type: "password"
            }, null, 8, ["label", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonFab), {
          horizontal: "end",
          vertical: "bottom",
          slot: "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonFabButton), { onClick: confirm }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})